import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spacing } from '../../components/entities-card/Spacing';
import { LawyerFollowButton } from './LawyerFollowButton';
import { LawyerCardTitle } from './LawyerCardTitle';
import {
  EntitiesList,
  EntitiesListItem,
  EntityValue,
} from '../../components/entities-card/EntitiesList';
import { LawyerCardInfosType } from '../lawyer.types';

type Props = {
  lawyer: Pick<
    LawyerCardInfosType,
    'title' | 'barreau' | 'lawyerId' | 'sermentDate'
  >;
  href: string | undefined;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const LawyerCardProfile: FC<Props> = ({ lawyer, href, onClick }) => {
  const isAvocatsAuxConseils = lawyer.barreau === 'Avocat aux conseils';
  return (
    <>
      <LawyerCardTitle href={href} onClick={onClick}>
        {lawyer.title}
      </LawyerCardTitle>
      <Spacing />
      <EntitiesList>
        {isAvocatsAuxConseils ? (
          <EntityValue>
            <FormattedMessage id="app.pages.lawyer.header.top.consulting" />
          </EntityValue>
        ) : (
          <EntitiesListItem
            left={<FormattedMessage id="app.pages.lawyer.card.bar" />}
            right={lawyer.barreau}
          />
        )}
        {lawyer.sermentDate && (
          <EntitiesListItem
            left={<FormattedMessage id="app.pages.lawyer.card.pledge" />}
            right={lawyer.sermentDate}
          />
        )}
      </EntitiesList>
      <Spacing />
      <LawyerFollowButton lawyerId={lawyer.lawyerId} name={lawyer.title} />
    </>
  );
};
